"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const components_overlay_Toggletip_components_ToggletipContainer = require("./components/ToggletipContainer.js");
const components_overlay_Toggletip_components_ToggletipDescription = require("./components/ToggletipDescription.js");
const components_overlay_Toggletip_components_ToggletipExplainer = require("./components/ToggletipExplainer.js");
const components_overlay_Toggletip_components_ToggletipPopover = require("./components/ToggletipPopover.js");
const Toggletip = ({
  message,
  showLabel,
  ariaLabel,
  placement,
  variant = "default",
  isOpen,
  id,
  ...props
}) => /* @__PURE__ */ jsxRuntime.jsxs(components_overlay_Toggletip_components_ToggletipContainer.ToggletipContainer, { placement, open: isOpen, ...props, children: [
  /* @__PURE__ */ jsxRuntime.jsx(components_overlay_Toggletip_components_ToggletipExplainer.ToggletipExplainer, { variant, ariaLabel, showLabel }),
  /* @__PURE__ */ jsxRuntime.jsx(components_overlay_Toggletip_components_ToggletipPopover.ToggletipPopover, { id, children: /* @__PURE__ */ jsxRuntime.jsx(components_overlay_Toggletip_components_ToggletipDescription.ToggletipDescription, { children: message }) })
] });
exports.Toggletip = Toggletip;
